import { render, staticRenderFns } from "./ImageScanOrderForm.vue?vue&type=template&id=6d2de6ed&scoped=true&"
import script from "./ImageScanOrderForm.vue?vue&type=script&lang=js&"
export * from "./ImageScanOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./ImageScanOrderForm.vue?vue&type=style&index=0&id=6d2de6ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2de6ed",
  null
  
)

export default component.exports